import { m } from '@hub/messages';
import type { MouseEvent } from 'react';

export interface SkipToMainLinkProps {
  targetId: string;
}

export function SkipToMainLink({ targetId }: SkipToMainLinkProps) {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    const target = document.getElementById(targetId);
    if (target) {
      e.preventDefault();
      target.focus();
    }
  };

  return (
    <a
      href={`#${targetId}`}
      onClick={handleClick}
      className="sr-only z-[1300] bg-primary p-2 text-white focus:not-sr-only focus:absolute focus:top-0 focus:left-0"
    >
      {m.commons_links_skip_to_main_content()}
    </a>
  );
}
